import { Factory, Rocket, ClipboardList } from "lucide-react";
import { FadeIn, SectionHeader } from "../components/Motion";

const GROUPS = [
  {
    icon: Factory,
    title: "Food Manufacturers & Co-Manufacturers",
    body: "Your clients constantly ask how long their product will last. Shelf Sense gives you a documented answer.",
  },
  {
    icon: Rocket,
    title: "SME Food Brand Founders",
    body: "Launching new products without a dedicated food-science team? You need a documented shelf-life date before you approach retailers.",
  },
  {
    icon: ClipboardList,
    title: "NPD & QA Professionals",
    body: "You need documented, science-backed shelf-life rationale on file for audits. Every Shelf Sense report is written to be filed and cited.",
  },
];

const Audience = () => (
  <section id="who" data-testid="audience-section" className="relative py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="03"
        label="Who we work with"
        title="Built for the people who carry the date on the pack."
      />
      <div className="mt-20 grid grid-cols-1 gap-5 md:grid-cols-3">
        {GROUPS.map((g, i) => (
          <FadeIn key={g.title} delay={i * 0.1}>
            <div
              className="group glass spotlight-frame h-full rounded-[2rem] p-8 transition-transform duration-500 hover:-translate-y-2"
              data-testid={`audience-card-${i}`}
            >
              <div className="inline-flex rounded-2xl border border-purple-500/30 bg-purple-600/10 p-3.5 transition-colors duration-500 group-hover:border-green-400/50 group-hover:bg-green-400/10">
                <g.icon className="h-7 w-7 text-purple-400 transition-colors duration-500 group-hover:text-green-300" />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold leading-snug text-slate-50">
                {g.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-slate-400">{g.body}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);

export default Audience;
